import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { pushGtmEvent } from "@/lib/analytics";

const LANDING_ROUTES: { path: RegExp; landing_type: string }[] = [
  { path: /^\/$/, landing_type: "home" },
  { path: /^\/for-businesses\/?$/, landing_type: "for_businesses" },
  { path: /^\/for-businesses\/booking-system-demo\/?$/, landing_type: "business_booking_system_demo" },
  { path: /^\/for-businesses\/booking-system-demo\/[^/]+\/?$/, landing_type: "business_booking_site_demo" },
  { path: /^\/apartment-manager\/partner-pulizie\/?$/, landing_type: "apartment_manager" },
  { path: /^\/servizi\/[^/]+\/[^/]+\/?$/, landing_type: "service_city_seo" },
  { path: /^\/aziende\/pulizie\/[^/]+\/?$/, landing_type: "vendor_city_seo" },
];

/**
 * SPA virtual page_view + view_landing for key marketing URLs (GTM/GA4).
 */
export default function AnalyticsRouteListener() {
  const location = useLocation();
  const lastRouteKey = useRef<string>("");

  useEffect(() => {
    const key = `${location.pathname}${location.search}|${location.key}`;
    if (lastRouteKey.current === key) return;
    lastRouteKey.current = key;

    const pagePath = `${location.pathname}${location.search}`;
    pushGtmEvent("page_view", {
      page_path: pagePath,
      page_title: typeof document !== "undefined" ? document.title : "",
    });

    const match = LANDING_ROUTES.find((r) => r.path.test(location.pathname));
    if (match) {
      pushGtmEvent("view_landing", {
        landing_type: match.landing_type,
        page_path: location.pathname,
      });
    }
  }, [location.pathname, location.search, location.key]);

  return null;
}
